export default __webpack_public_path__ + "static/media/github.5a3f0d2b.svg";